module.exports = __webpack_public_path__ + "img/volume-x.5fcb9829.svg";